import { motion } from "framer-motion";
import { WHY } from "../../lib/data";
import { Reveal, Overline, Icon } from "../ui-kit";

// Asymmetric bento spans for visual interest (12-col grid on lg)
const SPANS = [
  "lg:col-span-5", "lg:col-span-4", "lg:col-span-3",
  "lg:col-span-3", "lg:col-span-4", "lg:col-span-5",
  "lg:col-span-4", "lg:col-span-4", "lg:col-span-4",
  "lg:col-span-12",
];

export default function WhyChoose() {
  return (
    <section className="relative py-24 md:py-32 bg-[#080808]" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="max-w-2xl mb-14">
          <Overline index="04">Why Choose Sobtrex</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
            Built on <span className="text-orange-500">Principles</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-5">
          {WHY.map((w, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className={`group relative bg-[#121212] border border-zinc-800 hover:border-orange-500/50 p-8 transition-colors overflow-hidden ${SPANS[i]}`}
              data-testid={`why-card-${i}`}
            >
              <div className="absolute right-6 top-6 font-display text-5xl font-black text-white/5 group-hover:text-orange-500/10 transition-colors">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="h-12 w-12 flex items-center justify-center text-orange-500">
                <Icon name={w.icon} size={30} />
              </div>
              <h3 className="mt-6 font-display text-lg font-bold uppercase text-white leading-tight">{w.title}</h3>
              <p className="mt-2 text-sm text-zinc-500 leading-relaxed max-w-sm">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
